import React, { useState, useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import FractionsText from "./commonTextPages/FractionsText";
export default function FractionsHome() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fullScreenLayout">
      <NavbarGuest />
      <FractionsText />
      <div className="flex-grow-1"></div>
      <Footer />
      </div>
    </>
  );
}
